import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Post Reply',
  icon: 'reply',
  type: 'forum-reply-text',
  tag: 'interactivity',
  content: {
    received: 'Question received!',
    discussionId: '',
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
